<template>
  <div class="success-page">
    <div class="preview-tips" v-if="mode === 'preview'">
      此页面仅供预览效果，请勿转发投放！
    </div>
    <template v-if="mode === 'signin' && formConfig.enable_check === 1 && checkSubmitRes.check_time">
      <div class="top-wrap">
        <img class="check-pic" src="@/assets/img/success_check_pic.png" />
        <p class="text">签到成功</p>
        <p class="text-2">签到时间：{{ $filters.formatDate(checkSubmitRes.check_time, 'yyyy/MM/dd HH:mm') }}</p>
      </div>
      <div class="main-wrap">
        <p class="tips-text" v-if="siginText" v-html="siginTextFormat"></p>
        <p class="tips-text default" v-else>恭喜您签到成功！</p>
      </div>
    </template>
    <template v-else-if="mode !== 'signin'">
      <div class="top-wrap">
        <img class="check-pic" src="@/assets/img/success_check_pic.png" />
        <p class="text">提交成功</p>
        <p class="view-btn" @click="toViewForm()">
          查看提交记录
          <van-icon name="arrow" />
        </p>
      </div>
      <div class="main-wrap">
        <p class="tips-text" v-if="resultText" v-html="resultTextFormat"></p>
        <p class="tips-text default" v-else>恭喜您提交成功！</p>
      </div>
    </template>
  </div>
</template>

<script>
import { api } from "@/utils/fetch.js";
import { getQueryString } from '@/utils/tools.js';
import { Icon, Toast } from "vant";
import _ from 'lodash';
import format from 'date-fns/format';

export default {
  data() {
    return {
      resultText: '',
      mode: getQueryString('mode'),
      submitDetailData: {},
      siginText: '',
      checkSubmitRes: {}
    };
  },
  computed: {
    formConfig() {
      return this.$store.state.formConfig;
    },
    resultTextFormat() {
      console.log(this.resultText);
      return this.getFormatText(this.resultText);
    },
    siginTextFormat() {
      return this.getFormatText(this.siginText);
    }
  },
  
  components: {
    [Icon.name]: Icon
  },
  methods: {
    toViewForm() {
      this.$router.push({
        path: '/index',
        query: {
          ...this.$route.query,
          readonly: 1,
          view_submit: 1,
          _t: new Date().getTime()
        }
      });
    },
    getFormatText(text) {
      let textFormat = this.$filters.proxyWeixinImage(text);
      textFormat = textFormat?.replace(/\{\{(\d+)\}\}/g, (val1, val2) => {
        if (this.submitDetailData[val2] && (this.submitDetailData[val2].format_value !== null && this.submitDetailData[val2].format_value !== undefined)) {
          return this.submitDetailData[val2].format_value;
        }
        return '';
      });
      return textFormat;
    },
    getFormValue(item, formItem) {
      let value = null;
      if (item.data[formItem.id] && item.data[formItem.id].value) {
        const itemValue = item.data[formItem.id].value;
        if (['phone', 'weixin', 'email', 'location', 'score'].indexOf(formItem.type) >= 0) {
          value = itemValue;
        } else if (['text'].indexOf(formItem.type) >= 0) {
          value = itemValue?.replace(/\n/g, '<br/>') || '';
        } else if (['select'].indexOf(formItem.type) >= 0) {
          let index = formItem.option.findIndex((v) => v.id === itemValue);
          if (index >= 0) {
            value = formItem.option[index].name;
            if (item.data[formItem.id].special_value) {
              value = `${value}（${item.data[formItem.id].special_value}）`;
            }
          }
        } else if (['multi_select'].indexOf(formItem.type) >= 0) {
          let tmpArr = [];
          formItem.option.map((v) => {
            if (itemValue?.indexOf(v.id) >= 0) {
              if (v.special === 'other' && item.data[formItem.id].special_value) {
                tmpArr.push(`${v.name}（${item.data[formItem.id].special_value}）`);
              } else {
                tmpArr.push(v.name);
              }
            }
          });
          value = tmpArr.join('，');
        } else if (['matrix_select'].indexOf(formItem.type) >= 0) {
          const rows = formItem.option.filter((v) => v.type === 'matrix_row');
          const cols = formItem.option.filter((v) => v.type === 'matrix_col');
          let tmpArr = [];
          rows.map((v) => {
            let str = `${v.name}`;
            let index = cols.findIndex((v2) => v2.id === itemValue[v.id]);
            if (index >= 0) {
              str = `${str}：${cols[index].name}；`;
            } else {
              str = `${str}：暂无；`;
            }
            tmpArr.push(str);
          });
          value = tmpArr.join('<br/>');
        } else if (['date'].indexOf(formItem.type) >= 0) {
          value = format(itemValue * 1000, formItem.date_format === 'day' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm');
        } else if (['image_upload'].indexOf(formItem.type) >= 0) {
          let imgHtml = '';
          itemValue?.map(v => {
            imgHtml += `<img src="${v}"/>`;
          });
          value = imgHtml;
        }
      }
      
      if (item.data[formItem.id]) {
        item.data[formItem.id].format_value = value;
      }
      this.submitDetailData = _.cloneDeep(item.data);
    },
    async mapFormValue(form_id, submit_id) {
      await this.$store.dispatch('getFormFields', { id: form_id });
      await this.$store.dispatch('getSubmitDetail', { 
        form_id: form_id,
        submit_id: submit_id,
      });
      
      this.$nextTick(() => {
        document.title = this.$store.state.formConfig.title;
        this.siginText = this.$store.state.formConfig.check_message;
        this.$store.state.formItems?.map((formItem) => {
          this.getFormValue(this.$store.state.submitDetail, formItem);
        });
      });

    },
    async checkSubmit() {
      await api.CheckSubmit({ 
        id: this.$route.query.form_id
      }, true).then((res) => {
        if (getQueryString('mode') === 'signin' && res.id) {
          if (this.formConfig.enable_check) {
            this.toCheckIn(res.id);
          } else {
            Toast('表单未开启签到');
          }
          
        } else {
          this.mapFormValue(this.$route.query.form_id, this.$route.query.submit_id);
        }
        return res;
      }).catch((e) => {
        if (e.err_code === 10005) {
          Toast('请先填写并提交表单');
          this.$router.replace({
            path: '/index',
            query: {
              form_id: this.$route.query.form_id,
              channel_id: this.$route.query.channel_id,
              invite: this.$route.query.invite
            }
          });
        }
      });
    },
    toCheckIn(submit_id) {
      api.Check({ 
        form_id: this.$route.query.form_id,
        submit_id: submit_id
      }, true).then(async (res) => {
        this.checkSubmitRes = await api.CheckSubmit({ 
          id: this.$route.query.form_id
        }, true);
        this.mapFormValue(this.$route.query.form_id, submit_id);
        return res;
      }).catch((e) => {
        if (e.err_code === 10005) {
          // 10005：表单不存在或者提交不存在或者表单未开启签到
          Toast('表单未开启签到');
          this.mapFormValue(this.$route.query.form_id, submit_id);
        }
      });
    }
  },
  mounted() {
    this.resultText = sessionStorage.getItem(`RESULT_PARAM_CACHE_FORM_${this.$route.query.form_id}`);
    this.checkSubmit();
  }
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.success-page {
  position: relative;
  .preview-tips {
    background-color: #fff7e7;
    color: #FAAD14;
    font-size: @font-size-4;
    text-align: center;
    line-height: 42px;
  }
  .top-wrap {
    padding: 39px 0 30px 0;
    border-bottom: solid 5px #ecf1f3;
    .check-pic {
      display: block;
      width: 213px;
      margin: 0 auto;
    }
    .text {
      padding-top: 26px;
      font-weight: 700;
      font-size: @font-size-1;
      line-height: 25px;
      text-align: center;
      color: @desc-color-1;
    }
    .text-2 {
      font-size: 14px;
      line-height: 20px;
      color: @desc-color-2;
      text-align: center;
      margin-top: 6px;
    }
    .view-btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: var(--theme-main-color);
      text-align: center;
      margin-top: 12px;
    }
  }
  .main-wrap {
    padding: 24px 20px;
  }
  .tips-text {
    font-size: @font-size-3;
    line-height: 20px;
    color: @desc-color-1;
    padding: 0 20px 25px 20px;
    /deep/ img {
      max-width: 100%;
    }
    &.default {
      text-align: center;
    }
  }
}
</style>
